<!-- explain - rule [ 说明 - 规则 ] -->
<template>

    <div id='explainRule'>

        <!-- title -->
        <h1>补交阶梯差价计算说明</h1>

        <!-- table -->
        <div class="table">
            <el-table ref="filterTable" :data="tableData" style="width: 1200px;margin: auto;">
                <el-table-column prop="grade" label="年阶梯分档"></el-table-column>
                <el-table-column prop="range" label="电量"></el-table-column>
                <el-table-column prop="price" label="电价（元 / 度）">
                <template scope="scope">
                    <el-tag :type="scope.row.type === 0 ? 'success' : scope.row.type === 1 ? 'warning' : 'danger'" disable-transitions>￥ {{scope.row.price}}</el-tag>
                </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- content -->
        <div class="content">
            <el-alert type="info" style="margin-bottom: 20px;" description="电表设置电价说明：本年阶梯电表设置电价为无阶梯0.52元/度，电表本身计量一直按照0.52元/度计算，如果用量超出阶梯范围，则进行补交差价，补交差价在充值时自动扣除。" show-icon :closable="false"></el-alert>

            <el-collapse v-model="activeNames" @change="handleChange">

                <el-collapse-item title="计算公式：" name="1">
                    <p>（1）总电量＝第一档电量+第二档电量+第三档电量</p>
                    <p>（2）总电费＝第一档电费+第二档电费+第三档电费</p>
                    <p>（3）第一档电费 = 第一档标准以内的电量×原居民电价</p>
                    <p>（4）第二档电费 = 超出第一档标准并且在第二档标准以内的电量×（原居民电价+0.05元/度）</p>
                    <p>（5）第三档电费 = 超出第二档标准的电量×（原居民电价+0.3元/度）</p>

                    <small>注：第二档和第三档电费只有当居民实际用电量分别超出该档次标准才要计收</small>
                </el-collapse-item>

                <el-collapse-item title="计算示例：" name="2">
                    <p>①处于2阶梯电量（第一次补交阶梯差价）：</p>
                    <p>充值前本年用量 = 2190度</p>
                    <p>超出标准用量 = 2190度-2160度=30度</p>
                    <p>阶梯差价单价 = 0.05元/度</p>
                    <p>补交阶梯差价 = 30度*0.05元/度=1.5元</p>
                    <br />

                    <p>②处于2阶梯电量（第二次补交阶梯差价）</p>
                    <p>充值前本年用量 = 2580度</p>
                    <p>超出标准用量 = 2580度-2190度 = 390度</p>
                    <p>阶梯差价单价 = 0.05元/度</p>
                    <p>补交阶梯差价 = 390度*0.05元/度 =19.5元</p>
                    <br />

                    <p>③处于3阶梯电量（第三次补交阶梯差价）</p>
                    <p>充值前本年用量 = 3400度</p>
                    <p>超出2阶梯标准用量 = （3400度-3360度）=40度</p>
                    <p>超出1阶梯标准用量 = （3360度-2580度）=780度</p>
                    <p>补交阶梯差价 = 40度*0.30元/度 +780度*0.05元/度 = 51元</p>
                </el-collapse-item>

            </el-collapse>
        </div>
        
    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            tableData: [
                {
                    grade: '第 1 阶梯',
                    range: '0 ~ 2160度',
                    price: '0.52',
                    type: 0
                },
                {
                    grade: '第 2 阶梯',
                    range: '2160 ~ 3360度',
                    price: '0.57',
                    type: 1
                },
                {
                    grade: '第 3 阶梯',
                    range: '3360度以上',
                    price: '0.82',
                    type: 2
                },
            ],

            activeNames: ['1', '2'],
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },

        getData(){

        },
    },
}
</script>

<style scoped>
    body, html{
        margin: 0;
        padding: 0;
    }

    h1{
        padding: 30px 0;
        text-align: center;
        font-weight: 500;
    }

    .content{
        margin: auto;
        padding: 20px 0;
        width: 1200px;
    }
</style>

<style>
    .el-table .cell{
        text-align: center;
    }
    
    .el-alert--info{
        background-color: #f4f3f5 !important;
    }

    .el-alert--info .el-alert__icon{
        color: #909399;
    }

    .el-alert .el-alert__description{
        color: #909399 !important;
    }
</style>


// WEBPACK FOOTER //
// explainRule.vue?7184e453